import { Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Footer from "../Components/Footer";
import Innernavbar from "../Components/Innernavbar";
import {Helmet} from 'react-helmet';
import { useEffect, useState } from "react";
import apiService from "../apiService";
import Navbar from '../Components/Navbar';
import './output.css';
import Firsttheme from "./partnertheme/Firsttheme";
import Secondtheme from "./partnertheme/Secondtheme";
import Thirdtheme from "./partnertheme/Thirdtheme";
import Forththeme from "./partnertheme/Forththeme";
import Fifththeme from "./partnertheme/Fifththeme";
import Sixththeme from "./partnertheme/Sixththeme";
import Sevenththeme from "./partnertheme/Sevenththeme";
import Eighththeme from "./partnertheme/Eighththeme";
import Nineththeme from "./partnertheme/Nineththeme";
import Tenththeme from "./partnertheme/Tenththeme";
import Elevenththeme from "./partnertheme/Elevenththeme";
import Twelfththeme from "./partnertheme/Twelfththeme";
import Thirteenththeme from "./partnertheme/Thirteenththeme";
import Fourteenththeme from "./partnertheme/Fourteenththeme";
import Fifteenththeme from "./partnertheme/Fifteenththeme";
import Sixteenththeme from "./partnertheme/Sixteenththeme";
import Seventenththeme from "./partnertheme/Seventenththeme";
import Eighteenththeme from "./partnertheme/Eighteenththeme";
import Ninetenththeme from "./partnertheme/Ninetenththeme";
import Twentieththeme from "./partnertheme/Twentieththeme";
import Twentyfirsttheme from "./partnertheme/Twentyfirsttheme";
import Twentysecondtheme from "./partnertheme/Twentysecondtheme";
import Twentythirdtheme from "./partnertheme/Twentythirdtheme";
import Twentyfourththeme from "./partnertheme/Twentyfourththeme";
import Twentyfifththeme from "./partnertheme/Twentyfifththeme";
import Twentysixtheme from "./partnertheme/Twentysixtheme";
import Twentyseventheme from "./partnertheme/Twentyseventheme";
import Twentyeighththeme from "./partnertheme/Twentyeighththeme";
import Twentyninetheme from "./partnertheme/Twentyninetheme";
import Thirtieththeme from "./partnertheme/Thirtieththeme";

function PartnerStore(){
    const { slug } = useParams();
    const [searchParams] = useSearchParams();
    const [get_data, setget_data] = useState({});
    const [errorInfo, setErrorInfo] = useState(null);

    useEffect(()=>{
       get_user_data(slug)
    },[])

    const get_user_data = async(emp_id)=>{
        var emp_idd = {
            "slug":slug
        }
        const ar = await apiService.get_partner_data(emp_idd);
        console.log(ar);
        var data = ar["data"];
        if (data && (data.status === 0 || (Array.isArray(data.details) && data.details.length === 0))) {
            setErrorInfo({ message: data.message || "Plan expired or not buy any plan" });
            setget_data({});
        } else {
            const merged = {
                ...(data["details"] || {}),
                product_services: data["product_services"] || [],
                categories: data["categories"] || [],
                all_categories: data["all_categories"] || (data["details"] && data["details"]["all_categories"]) || [],
                review_ratings: data["review_ratings"] || [],
                service: data["service"] || null
            };
            setget_data(merged);
        }
    }
    return(
        <>
        {errorInfo ? (
            <>
                <Navbar />
                <style>{`
                .ps-hero{position:relative;display:flex;align-items:center;justify-content:center;min-height:80vh;padding:32px;background:radial-gradient(1200px 400px at 80% 0%,#eef2ff 0%,transparent 60%),linear-gradient(135deg,#f8fafc 0%,#f0f9ff 100%)}
                .ps-deco{position:absolute;inset:0;pointer-events:none}
                .ps-deco .b1{position:absolute;left:10%;top:15%;width:120px;height:120px;background:linear-gradient(180deg,#dbeafe,#fff);filter:blur(20px);border-radius:24px;opacity:.7}
                .ps-deco .b2{position:absolute;right:12%;bottom:12%;width:160px;height:160px;background:linear-gradient(180deg,#fff,#e9d5ff);filter:blur(24px);border-radius:32px;opacity:.6}
                .ps-box{position:relative;max-width:860px;width:96%;margin:0 auto;background:#fff;border-radius:24px;box-shadow:0 30px 60px rgba(15,27,42,.12);padding:40px 32px;overflow:hidden}
                .ps-ring{position:absolute;left:-60px;top:-60px;width:220px;height:220px;border-radius:50%;background:conic-gradient(from 200deg,#5b5cf7,#7d7df9,#5b5cf7);opacity:.2;filter:blur(10px)}
                .ps-icon{width:88px;height:88px;border-radius:18px;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#5b5cf7,#7d7df9);color:#fff;font-weight:700;box-shadow:0 16px 28px rgba(91,92,247,.25);margin:0 auto}
                .ps-chip{display:inline-flex;align-items:center;gap:8px;padding:6px 10px;border-radius:999px;background:#f1f5f9;color:#0f1b2a;font-weight:600;font-size:12px;margin-top:10px}
                .ps-title{margin-top:18px;font-size:32px;font-weight:800;color:#0f1b2a;text-align:center}
                .ps-sub{margin-top:8px;text-align:center;color:#64748b;font-size:16px}
                .ps-grid{display:grid;grid-template-columns:1fr;gap:20px;margin-top:24px}
                @media(min-width:768px){.ps-grid{grid-template-columns:1fr 1fr}}
                .ps-card{border:1px solid #e5e7eb;border-radius:16px;padding:16px}
                .ps-check{display:flex;align-items:center;gap:10px;margin-top:8px;color:#0f1b2a}
                .ps-check i{display:inline-flex;width:22px;height:22px;border-radius:50%;align-items:center;justify-content:center;background:#dcfce7;color:#16a34a;font-weight:700}
                .ps-actions{display:flex;gap:12px;justify-content:center;margin-top:28px;flex-wrap:wrap}
                .ps-btn{display:inline-flex;align-items:center;justify-content:center;padding:12px 18px;border-radius:12px;font-weight:600;text-decoration:none}
                .ps-primary{background:#0ea5e9;color:#fff;box-shadow:0 10px 20px rgba(14,165,233,.25)}
                .ps-secondary{background:#fff;color:#0f1b2a;border:1px solid #d1d5db}
                `}</style>
                <div className="ps-hero">
                    <div className="ps-deco"><div className="b1"></div><div className="b2"></div></div>
                    <div className="ps-box">
                        <div className="ps-ring"></div>
                        <div className="ps-icon">!</div>
                        <div className="ps-chip"><span>Status</span><span>Unavailable</span></div>
                        <div className="ps-title">Service Unavailable</div>
                        <div className="ps-sub">{errorInfo.message}</div>
                        <div className="ps-grid">
                            <div className="ps-card">
                                <div className="ps-check"><i>✓</i><span>Contact support for assistance</span></div>
                                <div className="ps-check"><i>✓</i><span>Review or upgrade partner plan</span></div>
                            </div>
                            <div className="ps-card">
                                <div className="ps-check"><i>✓</i><span>Keep your store information updated</span></div>
                                <div className="ps-check"><i>✓</i><span>Ensure payment is active</span></div>
                            </div>
                        </div>
                        <div className="ps-actions">
                            <a className="ps-btn ps-primary" href="/contact-us">Contact Reliep</a>
                          
                            <a className="ps-btn ps-secondary" href="/">Go Home</a>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        ) : (
            <>
                {(() => {
                    const themeParam = searchParams.get('theme');
                    const allowed = ["Firsttheme","Secondtheme","Thirdtheme", "Forththeme", "Fifththeme", "Sixththeme", "Sevenththeme", "Eighththeme", "Nineththeme", "Tenththeme", "Elevenththeme", "Twelfththeme", "Thirteenththeme", "Fourteenththeme", "Fifteenththeme", "Sixteenththeme", "Seventenththeme", "Eighteenththeme", "Ninetenththeme", "Twentieththeme", "Twentyfirsttheme", "Twentysecondtheme", "Twentythirdtheme", "Twentyfourththeme", "Twentyfifththeme", "Twentysixtheme", "Twentyseventheme", "Twentyeighththeme", "Twentyninetheme", "Thirtieththeme"];
                    
                    const paramMatch = allowed.find(item => item.toLowerCase() === (themeParam || '').toLowerCase());
                    const t = paramMatch ? paramMatch : (get_data && get_data.activated_theme);
                    if (t === "Firsttheme") return <Firsttheme get_data={get_data} />;
                    if (t === "Secondtheme") return <Secondtheme get_data={get_data} />;
                    if (t === "Forththeme") return <Forththeme get_data={get_data} />;
                    if (t === "Fifththeme") return <Fifththeme get_data={get_data} />;
                    if (t === "Sixththeme") return <Sixththeme get_data={get_data} />;
                    if (t === "Sevenththeme") return <Sevenththeme get_data={get_data} />;
                    if (t === "Eighththeme") return <Eighththeme get_data={get_data} />;
                    if (t === "Nineththeme") return <Nineththeme get_data={get_data} />;
                    if (t === "Tenththeme") return <Tenththeme get_data={get_data} />;
                    if (t === "Elevenththeme") return <Elevenththeme get_data={get_data} />;
                    if (t === "Twelfththeme") return <Twelfththeme get_data={get_data} />;
                    if (t === "Thirteenththeme") return <Thirteenththeme get_data={get_data} />;
                    if (t === "Fourteenththeme") return <Fourteenththeme get_data={get_data} />;
                    if (t === "Fifteenththeme") return <Fifteenththeme get_data={get_data} />;
                    if (t === "Sixteenththeme") return <Sixteenththeme get_data={get_data} />;
                    if (t === "Seventenththeme") return <Seventenththeme get_data={get_data} />;
                    if (t === "Eighteenththeme") return <Eighteenththeme get_data={get_data} />;
                    if (t === "Ninetenththeme") return <Ninetenththeme get_data={get_data} />;
                    if (t === "Twentieththeme") return <Twentieththeme get_data={get_data} />;
                    if (t === "Twentyfirsttheme") return <Twentyfirsttheme get_data={get_data} />;
                    if (t === "Twentysecondtheme") return <Twentysecondtheme get_data={get_data} />;
                    if (t === "Twentythirdtheme") return <Twentythirdtheme get_data={get_data} />;
                    if (t === "Twentyfourththeme") return <Twentyfourththeme get_data={get_data} />;
                    if (t === "Twentyfifththeme") return <Twentyfifththeme get_data={get_data} />;
                    if (t === "Twentysixtheme") return <Twentysixtheme get_data={get_data} />;
                    if (t === "Twentyseventheme") return <Twentyseventheme get_data={get_data} />;
                    if (t === "Twentyeighththeme") return <Twentyeighththeme get_data={get_data} />;
                    if (t === "Twentyninetheme") return <Twentyninetheme get_data={get_data} />;
                    if (t === "Thirtieththeme") return <Thirtieththeme get_data={get_data} />;
                    return <Thirdtheme get_data={get_data} />;
                })()}
            </>
        )}
        </>
    )
}
export default PartnerStore;